<template>
  <div class="container">
    <div class="school-body-index-teacher">
      <el-tabs v-model="activeName1" @tab-click="handleClick">
        <el-tab-pane label="开课班级" name="first">
          <el-row>
            <el-col :span="24">
              <div class="classwrapper">
                <el-row>
                  <el-col :span="24">
                    <div>
                      <el-form ref="form" :model="sizeForm" size="mini" :inline="true" @submit.native.prevent>
                        <el-form-item label="班级名称:">
                          <el-input style="width: 200px" v-model="sizeForm.classname" clearable @keyup.enter.native="onSubmit" placeholder="请输入班级名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                          <el-button size="mini" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                        </el-form-item>
                        <br />
                        <el-form-item label="所属科目:">
                          <el-radio-group v-model="sizeForm.subject_id" @change="onSubmit">
                            <el-radio label="">全部</el-radio>
                            <el-radio v-for="item of userSubject" :key="item.id" :label="item.id">{{ item.name
                            }}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <br />
                        <el-form-item label="上课日:">
                          <el-checkbox-group @change="onSubmit" v-model="sizeForm.typetime">
                            <el-checkbox label="1">周一</el-checkbox>
                            <el-checkbox label="2">周二</el-checkbox>
                            <el-checkbox label="3">周三</el-checkbox>
                            <el-checkbox label="4">周四</el-checkbox>
                            <el-checkbox label="5">周五</el-checkbox>
                            <el-checkbox label="6">周六</el-checkbox>
                            <el-checkbox label="7">周日</el-checkbox>
                          </el-checkbox-group>
                        </el-form-item>
                      </el-form>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="6" v-for="item in classList" :key="item.id">
                    <div class="classlist" @click="handleClassClick(item.id, item, '1')">
                      <div style="position: relative;" class="class_img Showcalendar" :style="{
                        backgroundImage: 'url(' + item.img_url + ')',
                      }">
                        <div class="isShowcalendar" @click.stop="calendar(item)" style="position: absolute; right: 10px; bottom: 10px; background:white;width:32px;height:32px;border-radius: 10px;">

                          <svg style="margin-left:4px;margin-top:4px;" t="1702610043956" class="icon" viewBox="0 0 1113 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14133" width="24" height="24">
                            <path d="M752.773565 236.27687a39.535304 39.535304 0 0 0 39.357218-39.357218V39.357217A39.535304 39.535304 0 0 0 752.773565 0a39.535304 39.535304 0 0 0-39.401739 39.357217v157.562435a39.535304 39.535304 0 0 0 39.401739 39.357218" fill="#000000" p-id="14134"></path>
                            <path d="M1030.054957 393.839304v472.598261a79.11513 79.11513 0 0 1-79.293218 78.758957H158.630957a79.159652 79.159652 0 0 1-79.33774-78.758957V393.839304h950.76174zM950.806261 78.758957h-128.712348v124.260173a69.231304 69.231304 0 0 1-69.36487 68.741566 68.741565 68.741565 0 0 1-69.320347-68.741566V78.758957H426.073043v124.260173a69.275826 69.275826 0 0 1-69.453913 68.741566 68.919652 68.919652 0 0 1-69.231304-68.741566V78.714435H158.630957C71.546435 78.714435 0 149.77113 0 236.27687v630.116173c0 86.550261 71.590957 157.562435 158.630957 157.606957h792.709565c87.084522 0 158.630957-71.012174 158.630956-157.562435V236.321391C1109.437217 149.77113 1037.801739 78.758957 950.806261 78.758957z" fill="#000000" p-id="14135"></path>
                            <path d="M356.129391 236.27687a39.535304 39.535304 0 0 0 39.401739-39.357218V39.357217A39.535304 39.535304 0 0 0 356.129391 0a39.535304 39.535304 0 0 0-39.357217 39.357217v157.562435a39.535304 39.535304 0 0 0 39.357217 39.357218" fill="#000000" p-id="14136"></path>
                            <path d="M729.711304 427.853913H390.144v464.717913h54.761739v-36.507826h230.043826v36.018087h54.761739V427.853913z m-284.761043 375.006609v-140.243479h229.999304v140.243479H444.950261z m0-193.491479v-128.311652h229.999304v128.311652H444.950261z" fill="#000000" p-id="14137"></path>
                          </svg>

                        </div>
                      </div>

                      <div class="class_room">
                        <el-row>
                          <el-col :span="24">
                            <div class="classname">
                              <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                <span>{{ item.name }}</span>
                              </el-tooltip>
                            </div>
                          </el-col>
                        </el-row>
                      </div>

                      <div class="class_time" style="margin-top: 10px; overflow: auto">
                        <span style="float: right; margin-right: 10px">
                          <span style="font-weight: bold; color: #909399">共</span>
                          {{ item.tchPlanNum }}
                          <span style="font-weight: bold; color: #909399">节</span>
                        </span>

                        <el-tag size="mini" style="float: left; margin-right: 10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399">{{
                            item.subjectName }}</el-tag>
                        <!--

                        <el-tag size="mini"
                          style="float: left; margin-right: 10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399"
                          v-if="item.curriculum_class_type === 2">试听班</el-tag>
                        <el-tag size="mini"
                          style="float: left; margin-right: 10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399"
                          v-if="item.curriculum_class_type === 1">正式班</el-tag>
-->

                        <el-tag style="margin-right:10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399" type="info" size="mini" v-for="item in item.week_json" :key="item">

                          <span v-if="item=='1'">周一</span>
                          <span v-if="item=='2'">周二</span>
                          <span v-if="item=='3'">周三</span>
                          <span v-if="item=='4'">周四</span>
                          <span v-if="item=='5'">周五</span>
                          <span v-if="item=='6'">周六</span>
                          <span v-if="item=='7'">周日</span>

                        </el-tag>

                      </div>

                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>

          <div style="margin: 20px; text-align: right" class="pagination-style">
            <el-pagination @current-change="handleCurrentClassPage" :current-page="page_no2" :page-size="page_size2" layout="total, prev, pager, next, jumper" :total="total2"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="补课班级" name="third">

          <el-row>
            <el-col :span="24">
              <div class="classwrapper">
                <el-row>
                  <el-col :span="24">
                    <div>
                      <el-form ref="form" :model="RemedialClassForm" size="mini" :inline="true" @submit.native.prevent>
                        <el-form-item label="班级名称:">
                          <el-input style="width: 200px" v-model="RemedialClassForm.classname" clearable @keyup.enter.native="onSubmit" placeholder="请输入班级名称"></el-input>
                        </el-form-item>
                        <el-form-item label="所属科目:">
                          <el-select v-model="RemedialClassForm.subject_id" placeholder="请选择科目" clearable>
                            <el-option label="全部" value></el-option>

                            <el-option v-for="item in userSubject" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item>
                          <el-button size="mini" type="primary" icon="el-icon-search" @click="onSubmit2">查询</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="6" v-for="item in remedialClass" :key="item.id">
                    <div class="classlist" @click="handleClassClick(item.id, item, '2')">
                      <div class="class_img" :style="{
                        backgroundImage: 'url(' + item.img_url + ')',
                      }"></div>
                      <div class="class_room">
                        <el-row>
                          <el-col :span="24">
                            <div class="classname">
                              <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                <span>{{ item.name }}</span>
                              </el-tooltip>
                            </div>
                          </el-col>
                        </el-row>
                      </div>

                      <div class="class_time" style="margin-top: 10px; overflow: auto">
                        <span style="float: right; margin-right: 10px">
                          <span style="font-weight: bold; color: #909399">共</span>
                          {{ item.tchPlanNum }}
                          <span style="font-weight: bold; color: #909399">节</span>
                        </span>
                        <el-tag size="mini" style="float: left; margin-right: 10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399">{{
                            item.subjectName }}</el-tag>
                        <el-tag size="mini" style="float: left; margin-right: 10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399" v-if="item.curriculum_class_type === 3">补课班</el-tag>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>

        </el-tab-pane>
        <el-tab-pane label="结业班级" name="second">
          <el-row>
            <el-col :span="24">
              <div class="classwrapper">
                <el-row>
                  <el-col :span="24">
                    <div>
                      <el-form ref="form" :model="sizeForm" size="mini" :inline="true" @submit.native.prevent>
                        <el-form-item label="班级名称:">
                          <el-input style="width: 200px" v-model="sizeForm.classname" clearable @keyup.enter.native="onSubmit1" placeholder="请输入班级名称"></el-input>
                        </el-form-item>
                        <el-form-item label="所属科目:">
                          <el-select v-model="sizeForm.subject_id" placeholder="请选择上课日期" clearable @change="getTchClasslist">
                            <el-option label="全部" value></el-option>

                            <el-option v-for="item in userSubject" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item>
                          <el-button size="mini" type="primary" @click="onSubmit1" icon="el-icon-search">查询</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="6" v-for="item in classList1" :key="item.id">
                    <div class="classlist" @click="handleClassClick(item.id, item, '1')">
                      <div class="class_img" :style="{
                        backgroundImage: 'url(' + item.img_url + ')',
                      }"></div>
                      <div class="class_room">
                        <el-row>
                          <el-col :span="24">
                            <div class="classname">
                              <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                <span>{{ item.name }}</span>
                              </el-tooltip>
                            </div>
                          </el-col>
                        </el-row>
                      </div>

                      <div class="class_time" style="margin-top: 10px; overflow: auto">
                        <span style="float: right; margin-right: 10px">
                          <span style="font-weight: bold; color: #909399">共</span>
                          {{ item.tchPlanNum }}
                          <span style="font-weight: bold; color: #909399">节</span>
                        </span>

                        <el-tag size="mini" style="float: left; margin-right: 10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399">{{
                            item.subjectName }}</el-tag>
                        <el-tag size="mini" style="float: left; margin-right: 10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399" v-if="item.curriculum_class_type === 2">试听班</el-tag>

                        <el-tag size="mini" style="float: left; margin-right: 10px;background:white; border:1px solid rgb(226, 226, 226);;color:#909399" v-if="item.curriculum_class_type === 1">正式班</el-tag>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>

          <div style="margin: 20px; text-align: right" class="pagination-style">
            <el-pagination @current-change="handleCurrentClassPage6" :current-page="page_no6" :page-size="page_size6" layout="total, prev, pager, next, jumper" :total="total6"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-drawer title="查看作品 (点击右上角X号退出)" size="100%" :visible.sync="drawer" :direction="direction" :destroy-on-close="true" @close="tchGetTchStuTchWorkList">
      <iframe id="iframe_project1" width="100%" height="100%" :src="project_url"></iframe>
    </el-drawer>

    <el-dialog :title="'学员姓名:' + wx_stu_name" :visible.sync="dialogVisible1" width="260px" :before-close="handleClose">
      <div style="text-align: center; margin-top: -20px">
        <el-image style="width: 200px; height: 200px" :src="code_url" fit="fill"></el-image>
      </div>

      <div style="text-align: center">
        <span>请家长用微信扫码,绑定账号</span>
      </div>
    </el-dialog>

    <el-dialog title="标记上课日" :visible.sync="dialogVisiblecalendar" width="400px">
      <el-select v-model="calendarList" multiple placeholder="请选择" style="width: 100%;">
        <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblecalendar = false">取 消</el-button>
        <el-button type="primary" @click="submitalendarList">确 定</el-button>
      </span>
    </el-dialog>
    <!--分享海报页面-->
    <div id="posterHtml" v-show="false" :style="{
      backgroundImage: 'url(' + share_img + ')',
      position: 'absolute',
      top: '0px',
      width: '1242px',
      height: '2208px',
    }">
      <div style="position: relative; top: 740px; text-align: center">
        <span style="font-weight: bold; color: white; font-size: 80px">
          {{ form_share.title }}
        </span>
        <br />
        <span style="color: white; font-size: 50px">
          {{ "作者:" + form_share.name }}
        </span>
      </div>

      <el-image style="margin-top: 765px; left: 180px; width: 902px; height: 665px" :src="form_share.cover" fit="fill">
      </el-image>

      <div id="qrcodeWorkImg" style="margin-left: 780px; margin-top: 108px"></div>
    </div>

    <div id="posterHtml1" v-show="false" :style="{
      backgroundImage: 'url(' + share_img + ')',
      position: 'absolute',
      top: '0px',
      width: '1242px',
      height: '2208px',
    }">
      <el-image style="margin-top: 618px; left: 122px; width: 1004px; height: 753px" :src="form_share.cover" fit="fill">
      </el-image>

      <div style="position: relative; top: 10px; text-align: center">
        <span style="font-weight: bold; color: #333333; font-size: 60px">
          {{ form_share.title }}
        </span>
        <br />
        <span style="color: #333333; font-size: 40px">
          {{ "作者:" + form_share.name }}
        </span>
      </div>

      <div style="margin-left: 230px; margin-top: 33px; color: #f7ba2a">
        <i v-for="count in form_share.star_num" :key="count" class="el-icon-star-on" style="font-size: 100px; margin: 10px"></i>
      </div>

      <div v-if="form_share.star_num" id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 212px"></div>
      <div v-else id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 365px"></div>
    </div>
  </div>
</template>

<script>
import {
  getTchClasslist,
  tchGetTchTimetable,
  tchGetStuTchPlanListByTchId,
  tchGetTchStuTchWorkList,
} from "@/api/classroom/teacher_api";

import { dateFormat } from "@/config/_filter";
import {
  getBaseInfo,
  getSchoolSubjectList,
  updateTchPlanSignState,
  getQrCode,
  getSchoolOpenMissClass,
  updateClassWeekJson
} from "@/api/educational.js";

import driverStep from "@/utils/guide/classlist_index_teacher";

export default {
  data() {
    return {
      classId: '',
      calendarList: [],
      options: [
        {
          id: '1',
          title: '周一'
        },
        {
          id: '2',
          title: '周二'
        },
        {
          id: '3',
          title: '周三'
        },
        {
          id: '4',
          title: '周四'
        },
        {
          id: '5',
          title: '周五'
        },
        {
          id: '6',
          title: '周六'
        },
        {
          id: '7',
          title: '周日'
        },

      ],
      dialogVisiblecalendar: false,
      //日期快捷选择
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      remedialClass: [],
      userSubject: [],
      classList1: [],
      classList: [],
      currentpage: 1,
      RemedialClassForm: {
        classname: "",
        subject_id: "", //科目
      },
      sizeForm: {
        typetime: [],
        classname: "",
        subject_id: "", //科目
        teaching_type: "", //课程类型
        course_week: "", //上课日期
        course_state: "", //班级状态
        course_time: "", //授课时段
        end_class_state: "0",
      },
      activeName: "first",
      activeName1: "first",

      //老师课表分页
      page_no: 1,
      page_size: 10,
      total: 0,

      //班级列表分页
      page_no2: 1,
      page_size2: 16,
      total2: 0,

      //作业点评分页
      page_no3: 1,
      page_size3: 20,
      total3: 0,

      //作业点评分页
      page_no6: 1,
      page_size6: 8,
      total6: 0,

      teaching_plan_list: [], //老师讲次类表
      CourseWork: [], //学员提交的作品
      markform: {
        markpoint: "",
        remark: "",
        is_good: false,
        is_only: false,
      }, //作品点评

      work_title: "", //项目名称
      work_url: "", //项目地址
      workinfo: {}, //预览的项目信息
      StuInfo: {},
      stu_name: "",

      tch_work_id: "",

      course_time: [],
      moresearch: true,

      teachplan_form: {
        date: [],
        sign_state: "",
        latest: true,
        default_time: "",
      },
      dialogVisible: false,
      subjectList: [], //校区科目列表
      CourseworkForm: {
        subject_code: "",
        is_marking: "",
        type: "",
      },

      subject_code: "",

      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,

      //JRCODE作品点评
      frameWidth1: 0, // 屏幕宽
      frameHeight1: 0, // 屏幕高

      //PYTHON作品点评
      frameWidth2: 0, // 屏幕宽
      frameHeight2: 0, // 屏幕高
      python_work_url: "",

      drawer: false,
      direction: "rtl",
      project_url: "",
      CourseWorkList: [],

      //绑定微信二维码
      dialogVisible1: false,
      code_url: "",
      wx_stu_name: "",

      //生成海报
      posterContent: "很不错", // 文案内容
      posterHtmlBg:
        "https://wugecdn.steam.fun/courses/b_scratch_course/bb_general_course/version2.0/poster/09%E5%B0%8F%E5%BF%83%E9%9B%AA%E5%B4%A9.png", // 背景图
      posterImg: "", // 最终生成的海报图片

      share_img: "", //默认海报
      share_type: "1", //海报类型

      form_share: {
        work_id: "",
        type: "1",
        color: "1",
        cover: "",
        title: "",
        name: "",
        star_num: 0,
        images1: [
          "https://wugecdn.steam.fun/resources/static/work_share/bg_blue_1.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_green_1.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_pink_1.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_red_1.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_1.png",
        ],
        images2: [
          "https://wugecdn.steam.fun/resources/static/work_share/bg_blue_2.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_green_2.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_pink_2.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_red_2.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_2.png",
        ],
      },
      share_loading: false, //生成海报加载

      //首页快捷跳转
      active: "", //跳转目标
    };
  },

  created() {
    this.getSchoolSubjectList();
    this.getBaseInfo();
  },

  mounted() {
    this.getTchClasslistHistory();
    this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50;
    this.frameHeight = this.frameWidth * 0.75 + 55;

    this.frameWidth1 = document.documentElement.clientWidth * 0.8 - 50;
    this.frameHeight1 = this.frameWidth1 * 0.5 + 55;

    this.frameWidth2 = document.documentElement.clientWidth * 0.8 - 50;
    this.frameHeight2 = this.frameWidth1 * 0.5 + 55;

    this.scale = this.frameWidth / 480;

    this.teachplan_form.default_time = dateFormat(); //默认查今天往后的课程

    this.activeName = this.$route.query.active
      ? this.$route.query.active
      : "first";

    this.tchGetTchTimetable();
    this.getTchClasslist();
  },

  activated() {
    console.log("组件激活");
    this.activeName = this.$route.query.active
      ? this.$route.query.active
      : "first";

    var that = this;

    if (this.CourseworkForm.subject_code) {
      if (this.activeName == "first") {
        console.log("点击我的课表");
        this.tchGetTchTimetable();
      } else if (this.activeName == "second") {
        console.log("点击我的班级");
        this.getTchClasslist();
      } else if (this.activeName == "third") {
        console.log("点击作品点评");
        this.tchGetTchStuTchWorkList();
      } else {
        console.log("点击我的课表");
        this.activeName = "first";
        this.tchGetTchTimetable();
      }
    } else {
      setTimeout(function () {
        // 这里就是处理的事件
        if (that.activeName == "first") {
          console.log("点击我的课表");
          that.tchGetTchTimetable();
        } else if (that.activeName == "second") {
          console.log("点击我的班级");
          that.getTchClasslist();
        } else if (that.activeName == "third") {
          console.log("点击作品点评");
          that.tchGetTchStuTchWorkList();
        } else {
          console.log("点击我的课表");
          that.activeName = "first";
          that.tchGetTchTimetable();
        }
      }, 300);
    }
  },

  methods: {

    submitalendarList() {
      console.log(this.calendarList)
      updateClassWeekJson({
        classId: this.classId,
        week_json: JSON.stringify(this.calendarList)
      }).then((res) => {
        console.log(res)
        this.$message.success('修改成功')
        this.getTchClasslist()
        this.dialogVisiblecalendar = false


      })
    },
    calendar(val) {
      if (val.week_json) {
        console.log(val.week_json)
        this.calendarList = val.week_json
      } else {
        this.calendarList = []
      }
      this.classId = val.id
      this.dialogVisiblecalendar = true
    },

    handleClick(val) {
      console.log(val, 78945);
      if (val.index == '1') {
        this.getSchoolOpenMissClass()
      }
    },
    onSubmit2() {
      this.getSchoolOpenMissClass()
    },
    getSchoolOpenMissClass() {
      getSchoolOpenMissClass({
        name: this.RemedialClassForm.classname,
        subject_id: this.RemedialClassForm.subject_id
      }).then((res) => {
        console.log(res, 789456);

        this.remedialClass = res.classList
      })
    },
    start() {
      this.$nextTick(() => {
        this.$driver.defineSteps(driverStep);
        this.$driver.start();
      });
    },

    compileStr(code) {
      //对字符串进行加密
      var c = String.fromCharCode(code.charCodeAt(0) + code.length);
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
      }
      return escape(c);
    },

    //字符串进行解密
    uncompileStr(code) {
      code = unescape(code);
      var c = String.fromCharCode(code.charCodeAt(0) - code.length);
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
      }
      return c;
    },

    handleClickTab() {
      if (this.activeName == "first") {
        console.log("点击我的课表");
        this.tchGetTchTimetable();
      } else if (this.activeName == "second") {
        console.log("点击我的班级");
        this.getTchClasslist();
      } else if (this.activeName == "third") {
        console.log("点击作品点评");
        this.tchGetTchStuTchWorkList();
      }
    },

    LatestCourse(e) {
      if (e.target.tagName === "INPUT") return; // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log("最近课程");
      console.log(this.teachplan_form.latest);

      if (!this.teachplan_form.latest) {
        this.teachplan_form.default_time = dateFormat(); //获得当前时间
        this.teachplan_form.date = [];
      } else {
        this.teachplan_form.default_time = "";
      }
      this.page_no = 1;
      this.tchGetTchTimetable();
      console.log(this.teachplan_form.default_time);
    },

    handleCurrentChange(val) {
      this.page_no3 = val;
      this.tchGetTchStuTchWorkList();
    },

    //获取学校科目权限列表
    getSchoolSubjectList() {
      console.log("校区ID");
      console.log(this.campusId);
      getSchoolSubjectList().then((res) => {
        this.subjectList = res.subjectList;
        console.log("获取学校科目权限列表");
        console.log(res);

        if (res.subjectList.length == 0) {
          this.$message.warning("无科目权限");
          return;
        }
        this.CourseworkForm.subject_code = res.subjectList[0].code;
      });
    },

    //查询校区上课时段

    getBaseInfo() {
      getBaseInfo().then((res) => {
        console.log("校区授课时段");
        console.log(res);
        this.course_time = res.educational_institution_class_day_list;
      });
    },

    getTchClasslistHistory() {
      console.log("班级状态");
      console.log(this.sizeForm.course_state);
      getTchClasslist({
        subject_id: this.sizeForm.subject_id,
        teaching_type: this.sizeForm.teaching_type,
        course_state: this.sizeForm.course_state,
        course_week: this.sizeForm.course_week,
        course_time: this.sizeForm.course_time,
        end_class_state: 1,
        name: this.sizeForm.classname,
        page_no: this.page_no6,
        page_size: this.page_size6,
      }).then((res) => {
        console.log("获取班级列表");
        console.log(res);
        this.total6 = res.classlist_total;
        res.classlist.map((item) => {
          console.log(item.img_url, 78946);
          if (item.img_url === undefined || item.img_url === '' || item.img_url === null) {
            item.img_url = 'https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/static/060798de-c2de-4b7a-9952-3175982472bc/21020-体验.png'
          }
        })
        this.userSubject = res.userSubject; //用户科目
        this.classList1 = res.classlist; //班级列表
      });
    },

    //查询班级列表
    getTchClasslist() {
      console.log("班级状态");
      console.log(this.sizeForm.course_state);

      getTchClasslist({
        end_class_state: 0,
        week_json: JSON.stringify(this.sizeForm.typetime),
        subject_id: this.sizeForm.subject_id,
        teaching_type: this.sizeForm.teaching_type,
        course_state: this.sizeForm.course_state,
        course_week: this.sizeForm.course_week,
        course_time: this.sizeForm.course_time,
        name: this.sizeForm.classname,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log("获取班级列表");
        console.log(res);
        this.total2 = res.classlist_total;
        res.classlist.map((item) => {
          console.log(item.img_url, 78946);
          if (item.img_url === undefined || item.img_url === '' || item.img_url === null) {
            item.img_url = 'https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/static/060798de-c2de-4b7a-9952-3175982472bc/21020-体验.png'
          }
        })
        this.userSubject = res.userSubject; //用户科目
        this.classList = res.classlist; //班级列表
      });
    },

    //根据讲次查询学员课堂作品和学员课后作业完成情况
    tchGetStuTchPlanListByTchId(tch_plan_id) {
      console.log("讲次相关作品查询");
      console.log(tch_plan_id);

      tchGetStuTchPlanListByTchId({
        tch_plan_id: tch_plan_id,
      }).then((res) => {
        console.log("查询讲次的课堂作品和作业作品");
        console.log(res);
        this.CourseWork = res.stuTchPlanList;
      });
    },

    //作品打分
    MarkWork(id, workinfo, stuinfo, subjectinfo) {
      this.work_title = workinfo.title;
      this.work_url = workinfo.work_url;
      this.workinfo = workinfo;
      this.StuInfo = stuinfo;
      this.stu_name = stuinfo.studentUserInfo.realname;
      this.tch_work_id = workinfo.id;

      this.subject_code = subjectinfo.code;

      //课表页面查看修改学员课堂作品

      if (workinfo.is_marking) {
        this.markform = {
          is_good: workinfo.is_good,
          is_only: workinfo.is_only,
          markpoint: workinfo.markpoint,
          remark: workinfo.remark,
        };
      } else {
        this.markform = {
          is_good: false,
          is_only: false,
          markpoint: "",
          remark: "",
        };
      }

      console.log(id);
      console.log("workinfo");
      console.log(this.workinfo);
      console.log("stuinfo");
      console.log(this.StuInfo);
      console.log("subject_code");
      console.log(this.subject_code);

      if (this.subject_code == "1") {
        this.project_url =
          "/jrcode/teachjr.html?mode=edit&filepath=" +
          this.work_url +
          "&mode=edit";
        this.drawer = true;
      } else if (this.subject_code == "2") {
        console.log("SC作品查看");

        //this.dialogFormVisible = true;
        this.project_url =
          "/scratch/teachsc.html?workurl=" +
          this.compileStr(this.work_url).replace(/%/g, "%25") +
          "&workname=" +
          this.work_title +
          "&type=2";
        this.drawer = true;
      } else if (this.subject_code == "3") {
        this.project_url = "/python/teachpy?type=3&title=" + this.work_title;
        this.$store.commit(
          "SET_TEACH_TEMPLATE_URL",
          this.workinfo.work_url || ""
        );
        this.drawer = true;
      }
    },
    //设置评语
    SetComment(val) {
      console.log(val);
      this.markform.remark = this.markform.remark + val;
    },

    LookOneWork(row) {
      console.log("查看1个作品");
      console.log(row);

      this.work_title = row.title;
      this.work_url = row.work_url;
      this.workinfo = row;
      // this.StuInfo = stuinfo;
      // this.stu_name = stuinfo.studentUserInfo.realname;
      this.tch_work_id = row.id;

      if (row.is_marking) {
        this.markform = {
          is_good: row.is_good,
          is_only: row.is_only,
          markpoint: row.markpoint,
          remark: row.remark,
        };
      } else {
        this.markform = {
          is_good: false,
          is_only: false,
          markpoint: "",
          remark: "",
        };
      }

      console.log("workinfo");
      console.log(this.workinfo);
      console.log("stuinfo");
      console.log(this.StuInfo);

      if (this.CourseworkForm.subject_code == "1") {
        this.project_url =
          "/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=" +
          row.work_url +
          "&stu_user_id=" +
          row.stu_user_id +
          "&stu_tch_plan_id=" +
          row.stu_tch_plan_id +
          "&work_type=" +
          row.work_type;
        this.drawer = true;
      } else if (this.CourseworkForm.subject_code == "2") {
        console.log("SC作品查看");

        //this.dialogFormVisible = true;
        this.project_url =
          "/scratch/teachsc.html?workurl=" +
          this.compileStr(row.work_url).replace(/%/g, "%25") +
          "&workname=" +
          row.title +
          "&stu_user_id=" +
          row.stu_user_id +
          "&stu_tch_plan_id=" +
          row.stu_tch_plan_id +
          "&work_type=" +
          row.work_type +
          "&mode=4";

        console.log("URL");
        console.log(this.project_url);

        this.drawer = true;
      } else if (this.CourseworkForm.subject_code == "3") {
        this.project_url =
          "/python/teachpy?mode=4&title=" +
          this.work_title +
          "&stu_user_id=" +
          row.stu_user_id +
          "&stu_tch_plan_id=" +
          row.stu_tch_plan_id +
          "&work_type=" +
          row.work_type;

        this.$store.commit("SET_TEACH_TEMPLATE_URL", row.work_url || "");
        this.drawer = true;
      }
    },

    LookOneWorkTable(row, type) {
      console.log("老师课表中查看学员作品");
      console.log(row);

      if (row.subject_id == "1") {
        if (type == "1") {
          this.project_url =
            "/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=" +
            row.classWorkInfo.work_url +
            "&stu_user_id=" +
            row.student_user_id +
            "&stu_tch_plan_id=" +
            row.classWorkInfo.stu_tch_plan_id +
            "&work_type=" +
            row.classWorkInfo.work_type;
        } else if (type == "2") {
          this.project_url =
            "/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=" +
            row.homeWorkInfo.work_url +
            "&stu_user_id=" +
            row.student_user_id +
            "&stu_tch_plan_id=" +
            row.homeWorkInfo.stu_tch_plan_id +
            "&work_type=" +
            row.homeWorkInfo.work_type;
        }

        this.drawer = true;
      } else if (row.subject_id == "2") {
        console.log("SC作品查看");

        if (type == "1") {
          this.project_url =
            "/scratch/teachsc.html?workurl=" +
            this.compileStr(row.classWorkInfo.work_url).replace(/%/g, "%25") +
            "&workname=" +
            row.classWorkInfo.title +
            "&stu_user_id=" +
            row.student_user_id +
            "&stu_tch_plan_id=" +
            row.classWorkInfo.stu_tch_plan_id +
            "&work_type=" +
            row.classWorkInfo.work_type +
            "&mode=4";
        } else if (type == "2") {
          this.project_url =
            "/scratch/teachsc.html?workurl=" +
            this.compileStr(row.homeWorkInfo.work_url).replace(/%/g, "%25") +
            "&workname=" +
            row.homeWorkInfo.title +
            "&stu_user_id=" +
            row.student_user_id +
            "&stu_tch_plan_id=" +
            row.homeWorkInfo.stu_tch_plan_id +
            "&work_type=" +
            row.homeWorkInfo.work_type +
            "&mode=4";
        }

        console.log("URL");
        console.log(this.project_url);

        this.drawer = true;
      } else if (row.subject_id == "3") {
        if (type == "1") {
          this.project_url =
            "/python/teachpy?mode=4&title=" +
            row.classWorkInfo.title +
            "&stu_user_id=" +
            row.student_user_id +
            "&stu_tch_plan_id=" +
            row.classWorkInfo.stu_tch_plan_id +
            "&work_type=" +
            row.classWorkInfo.work_type;

          this.$store.commit(
            "SET_TEACH_TEMPLATE_URL",
            row.classWorkInfo.work_url || ""
          );
        } else if (type == "2") {
          this.project_url =
            "/python/teachpy?mode=4&title=" +
            row.homeWorkInfo.title +
            "&stu_user_id=" +
            row.student_user_id +
            "&stu_tch_plan_id=" +
            row.homeWorkInfo.stu_tch_plan_id +
            "&work_type=" +
            row.homeWorkInfo.work_type;

          this.$store.commit(
            "SET_TEACH_TEMPLATE_URL",
            row.homeWorkInfo.work_url || ""
          );
        }

        this.drawer = true;
      }
    },

    search3() {
      this.page_no3 = 1;
      this.tchGetTchStuTchWorkList();
    },

    tchGetTchStuTchWorkList() {
      if (!this.CourseworkForm.subject_code) {
        this.$message.warning("请选择科目");
        return;
      }

      console.log("科目信息");
      console.log(this.CourseworkForm.subject_code);

      tchGetTchStuTchWorkList({
        subject_code: this.CourseworkForm.subject_code,
        is_marking: this.CourseworkForm.is_marking,
        work_type: this.CourseworkForm.type,
        title: this.CourseworkForm.title,
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log("学生课堂作品");
        console.log(res);
        this.CourseWorkList = res.workList;
        this.total3 = res.total;
      });
    },

    onSubmit() {
      this.page_no2 = 1
      this.getTchClasslist();
    },
    onSubmit1() {
      this.page_no6 = 1
      this.getTchClasslistHistory();
    },

    search() {
      this.page_no = 1;
      this.teachplan_form.default_time = "";
      this.teachplan_form.latest = false;
      this.tchGetTchTimetable();
    },

    //获得老师课表
    tchGetTchTimetable() {
      tchGetTchTimetable({
        title: this.teachplan_form.title,
        sign_state: this.teachplan_form.sign_state,
        start_date: this.teachplan_form.default_time
          ? this.teachplan_form.default_time
          : this.teachplan_form.date
            ? this.teachplan_form.date[0]
            : "", // 开始时间
        end_date: this.teachplan_form.date ? this.teachplan_form.date[1] : "", // 结束时间
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("查询老师课表");
        console.log(res);
        this.teaching_plan_list = res.teaching_plan_list;
        this.total = res.total;
      });
    },

    //去上课
    goTeachlessons(item) {
      console.log("去上课");
      console.log(item);

      if (item.sign_state == "1") {
        console.log("课堂已解锁");
        this.$router.push({
          name: "teachLessons",
          query: {
            curriculumMaterial_id: item.curriculum_meterial_id,
            backname: "myClass",
            classid: item.curriculum_class_id,
            teaching_plan_id: item.id,
          },
        });
      } else {
        this.$confirm(
          "对学生进行【点名签到】后,学生端课程才可以解锁!",
          "提示",
          {
            confirmButtonText: "知道了",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.updateTchPlanSignState(item);
        });
      }
    },

    //更新教学计划的签到状态
    updateTchPlanSignState(item) {
      updateTchPlanSignState({
        teaching_plan_id: item.id,
      }).then((res) => {
        console.log("更新教学计划的签到状态");
        console.log(res);
        if (res.is_update) {
          this.$message.success("课程已解锁,可以开始上课啦!");
          this.$router.push({
            name: "teachLessons",
            query: {
              curriculumMaterial_id: item.curriculum_meterial_id,
              backname: "myClass",
              classid: item.curriculum_class_id,
              teaching_plan_id: item.id,
            },
          });
        }
      });
    },

    //去备课
    prepare(item) {
      console.log(item);

      this.$router.push({
        name: "prepare",
        query: {
          curriculumMaterial_id: item.curriculum_meterial_id,
          tchPlanId: item.id,
          backname: "myClass",
          classid: item.curriculum_class_id,
        },
      });
    },

    //获得学员带参二维码
    getQrCode(row) {
      console.log("学员信息");
      console.log(row);
      console.log(row.stu_user_id);

      this.wx_stu_name = row.name;

      getQrCode({
        stuId: row.stu_user_id,
      }).then((res) => {
        console.log("绑定学员家长微信");
        console.log(res);

        this.code_url =
          "data:image/jpeg;base64," +
          this.arrayBufferToBase64(res.qucodeData.data);
        console.log("url", this.code_url);

        this.dialogVisible1 = true;
      });
    },

    arrayBufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary); //base64
    },

    handleClose() {
      this.dialogVisible1 = false;
      this.tchGetTchStuTchWorkList();
    },

    handleCurrentPlanPage(val) {
      this.page_no = val;
      this.tchGetTchTimetable();
    },

    handleCurrentClassPage(val) {
      this.page_no2 = val;
      this.getTchClasslist();
    },
    handleCurrentClassPage6(val) {
      this.page_no6 = val;
      this.getTchClasslistHistory();
    },
    handleCurrentWorks(val) {
      this.page_no3 = val;
      this.tchGetTchStuTchWorkList();
    },

    handleClassClick(id, item, type1) {
      console.log("班级ID");
      console.log(id, 4547878);
      console.log(item, 4547878)
      this.$router.push({
        name: "classlistDescTeacher",
        query: {
          type1: type1,
          class_id: id,
          end_class_state: item.end_class_state
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.Showcalendar {
  cursor: pointer;
}

.Showcalendar:hover .isShowcalendar {
  display: block;
}

.isShowcalendar {
  display: none;
}

.school-body-index-teacher {
  background: white;
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  border-radius: 5px;
  margin: 10px;

  .classwrapper {
    background: white;

    .classtype {
    }

    .classlist {
      border: 1px solid rgb(226, 226, 226);
      margin: 15px;
      border-radius: 5px;
      padding-bottom: 10px;

      .class_img {
        display: block;
        width: 100%;
        height: 0;
        padding-bottom: 69%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 5px 5px 0px 0px;

        .classimg {
          width: 100%;

          border-radius: 5px 5px 0px 0px;
        }
      }

      .class_room {
        margin-top: 10px;

        .classname {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: bold;
          padding-left: 10px;
          font-size: 16px;
        }
      }

      .class_time {
        padding-left: 10px;
        white-space: nowrap;
      }

      .class_num {
        padding-left: 10px;
        line-height: 20px;
      }
    }

    .pagesdiv {
      text-align: center;
      padding: 10px;
    }
  }

  .classlist_wrapper {
    .classlist-imgwrapper {
      .classimg_wrapper_img {
        width: 100%;
        border-radius: 5px;
        margin-top: 10%;
      }
    }

    .classlist-content {
      flex: 1;
      display: flex;
      flex-flow: column;

      .classlist-content-title {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;
        font-weight: 500;

        .coursetitle {
          padding-right: 10px;
          font-weight: 800;
        }
      }

      .classlist-content-desc {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

        .content-desc {
          padding-right: 20px;
        }
      }

      .classlist-content-date {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;
      }
    }

    .classlist-btn {
      height: 140px;
      line-height: 140px;

      text-align: center;

      .drop_btn {
        margin-right: 20px;
        margin-top: 60px;
      }

      .class_btn {
        margin-top: 60px;
        margin-right: 20px;
      }
    }

    .pagination-style {
      margin: 20px;
    }
  }

  /*
#qrcodeImg {
  box-sizing: border-box;
  display: inline-block;
  padding: 8px;
  background: #cccccc;
  & > img {
    display: inline-block !important;
  }
}
*/
}
</style>

<style>
/* .el-popover {
  background: #f5f7fa;
}

.container .el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  font-weight: bold;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
} */
</style>
 
